import { formatters } from './formatters.js'
import { serializers } from './serializers.js'

export const chainConfig = {
  formatters,
  serializers,
} as const
